export default __webpack_public_path__ + "static/media/investors_logo7.819afc9b.png";